if (!customElements.get('ka-black-friday')) {
  class KaBlackFriday extends HTMLElement {
    connectedCallback() {
      this.end = Number(this.dataset.endsAt) * 1000;
      this.controller = new AbortController();
      this.addEventListener('click', event => {
        const more = event.target.closest('[data-bf-load-more]');
        if (more && this.contains(more)) { this.loadMore(more); return; }
      }, {signal: this.controller.signal});
      this.tick();
    }
    disconnectedCallback() {
      this.controller?.abort();
      clearTimeout(this.timer);
    }
    tick() {
      clearTimeout(this.timer);
      const remaining = this.end - Date.now();
      const ended = !Number.isFinite(remaining) || remaining <= 0;
      this.classList.toggle('is-ended', ended);
      this.querySelector('[data-sale-ended]').hidden = !ended;
      const total = Math.max(0, Math.floor(remaining / 1000)) || 0;
      const values = {days: Math.floor(total / 86400), hours: Math.floor(total % 86400 / 3600), minutes: Math.floor(total % 3600 / 60), seconds: total % 60};
      for (const [key, value] of Object.entries(values)) this.querySelector(`[data-bf-${key}]`).textContent = String(value).padStart(2, '0');
      this.querySelector('[data-bf-countdown]').setAttribute('aria-label', `${values.days} days, ${values.hours} hours, ${values.minutes} minutes and ${values.seconds} seconds remaining`);
      if (!ended) this.timer = setTimeout(() => this.tick(), Math.min(1010 - Date.now() % 1000, remaining));
    }
    async loadMore(button) {
      if (button.disabled) return;
      const group = button.closest('[data-bf-group]');
      const status = group.querySelector('[data-bf-load-status]');
      const previousLabel = button.dataset.moreLabel || button.textContent;
      button.dataset.moreLabel = previousLabel;
      button.disabled = true; button.textContent = 'LOADING DEALS…';
      try {
        const url = new URL(button.dataset.nextUrl, location.href);
        if (url.origin !== location.origin) throw new Error('Unexpected pagination host');
        const current = new URL(location.href);
        for (const key of ['view', 'preview_theme_id', '_fd', 'pb']) if (current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
        url.searchParams.set('section_id', this.dataset.sectionId);
        const response = await fetch(url.href, {signal: this.controller.signal, credentials: 'same-origin'});
        if (!response.ok) throw new Error('Section unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const nextGroup = Array.from(doc.querySelectorAll('[data-bf-group]')).find(g => g.dataset.bfGroup === group.dataset.bfGroup);
        const cards = nextGroup?.querySelectorAll('.ka-bf26__grid > product-card');
        if (!cards?.length) throw new Error('No next page');
        group.querySelector('.ka-bf26__grid').append(...cards);
        const nextButton = nextGroup.querySelector('[data-bf-load-more]');
        status.textContent = `${cards.length} more deals loaded.`;
        if (nextButton) { button.dataset.nextUrl = nextButton.dataset.nextUrl; button.textContent = previousLabel; }
        else button.remove();
      } catch (error) {
        if (error.name !== 'AbortError') { button.textContent = 'TRY AGAIN'; status.textContent = 'Could not load more deals. Please try again.'; }
      } finally { if (button.isConnected) button.disabled = false; }
    }
  }
  customElements.define('ka-black-friday', KaBlackFriday);
}
